import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  AutocompleteInput,
  DateInput,
  ReferenceInput,
  SimpleForm,
  TextInput,
  NumberInput,
  required,
  usePermissions,
} from 'react-admin';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { parseDate } from '../../../helpers';
import {
  CatalogItemAutocompleteInput,
  ContractAutocompleteInput,
  Toolbar,
} from '../../../components';
import { getUser } from '../../../user';

const sanitizeRestProps = ({
  hasShow,
  hasEdit,
  hasList,
  hasCreate,
  ...props
}) => {
  return props;
};

const ProviderInvoiceForm = ({ onCancel, record, ...props }) => {
  // Fail closed: rely on react-admin permissions, fall back to the stored
  // user while the async AUTH_GET_PERMISSIONS call hasn't resolved yet (same
  // repli pattern as Cleaner/detail/Form.js and
  // Vivier/components/WarningsCard.js). This form is mounted by
  // ProviderInvoice/List.js's DrawerCreateEdit, not by a react-admin
  // <Resource edit=/> route, but usePermissions() only needs the AuthContext
  // provided at <Admin> level, so it works the same inside the Drawer.
  const { permissions } = usePermissions();
  const user = permissions || getUser();

  // Mirror the server-side check (postgRest.js: hasPermission(user,
  // 'provider_invoice', 'delete', 1)) instead of a hardcoded role test, same
  // motif as Cleaner/detail/Form.js. `isCreate` keeps the button off the
  // Create screen (this Form is shared by ProviderInvoice/Create.js and
  // ProviderInvoice/Edit.js, both rendered by the Drawer).
  const isCreate = !record || !record.id;
  const isDeletable =
    !isCreate && !!(user?.permissions?.provider_invoice?.delete >= 1);

  return (
    <Fragment>
      <div style={{ textAlign: 'right' }}>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </div>
      <SimpleForm
        {...sanitizeRestProps(props)}
        record={record}
        toolbar={<Toolbar isDeletable={isDeletable} />}
      >
        <NumberInput source="amount" step={0.01} validate={[required()]} />
        <DateInput source="date" parse={parseDate} />
        <CatalogItemAutocompleteInput validate={[required()]} />
        <ContractAutocompleteInput validate={required()} />
        <ReferenceInput
          filterToQuery={(searchText) => {
            return { name: searchText };
          }}
          source="provider_account_id"
          reference="account"
          validate={[required()]}
        >
          <AutocompleteInput
            source="name"
            options={{
              suggestionsContainerProps: {
                /* XXX: no other way to give style to the AutocompleList. react-admin not passing classes to AutocompleList in AutocompleInput */
                style: { zIndex: 2000 },
              },
            }}
          />
        </ReferenceInput>
        <TextInput source="invoice_number" />
        <NumberInput
          source="amortization"
          defaultValue={1}
          step={1}
          validate={[required()]}
        />
      </SimpleForm>
    </Fragment>
  );
};

ProviderInvoiceForm.propTypes = {
  onCancel: PropTypes.func,
  record: PropTypes.object,
};

ProviderInvoiceForm.defaultProps = {
  onCancel: /* istanbul ignore next */ () => {},
  record: {},
};

export default ProviderInvoiceForm;
